import React, { useCallback, useEffect, useState } from 'react'
import { Box, Typography, makeStyles, ClickAwayListener, useTheme, Popper, Grow, Paper, IconButton } from '@material-ui/core'
import { listarLaboratorios, trocarLaboratorio } from '../LoginManager'
import { connect } from 'react-redux'
import { debounce } from "lodash";
import ModalTrocaLaboratorio from './ModalTrocaLaboratorio';
import { SECONDARY_COLOR } from '../../../theme';
import store from '../../../store';
import { MENSAGEM_NAO_EXISTEM_LABORATORIOS, MENSAGEM_PADRAO_TROCA_LABORATORIO } from '../../../shared/utils/Constantes';

const TrocaLaboratorio = props => {
    const {
        icone,
        referenciaAncora,
        usuario
    } = props;

    const theme = useTheme();
    const classes = useStyles({ theme });

    const [aberto, setAberto] = useState(false);
    const [termoBusca, setTermoBusca] = useState("");
    const [carregando, setCarregando] = useState(false);
    const [laboratorios, setLaboratorios] = useState([]);
    const [modalAberto, setModalAberto] = useState(false);
    const ehUsuarioCpf = !isNaN(parseFloat(usuario?.usuario));
    const [codigoSelecionado, setCodigoSelecionado] = useState(null);
    const [mensagem, setMensagem] = useState(MENSAGEM_PADRAO_TROCA_LABORATORIO);
    const [popperWidth, setPopperWidth] = useState(null);

    const atualizarLarguraPopper = useCallback(() => {
        if (referenciaAncora.current) {
            const rect = referenciaAncora.current.getBoundingClientRect();
            setPopperWidth(rect.width);
        }
    }, [referenciaAncora]);

    const handleToggle = () => {
        setAberto(abertoAnterior => !abertoAnterior);
    };

    const handleClose = event => {
        if (referenciaAncora?.current?.contains(event?.target)) {
            return;
        }

        setAberto(false);
    };

    const abrirModal = () => {
        setAberto(false);

        if (ehUsuarioCpf) {
            setTermoBusca("");
            setCarregando(true);
            listarLaboratorio();
            setModalAberto(true);
        }
        else {
            setModalAberto(true);
        }
    };

    const fecharModal = () => {
        setModalAberto(false);
        setTermoBusca("");
        setLaboratorios([]);
        setCodigoSelecionado("");
    };

    const listarLaboratorio = useCallback(debounce(async () => {
        if (!ehUsuarioCpf && termoBusca?.length === 0) {
            return;
        }

        setCarregando(true);

        await listarLaboratorios(termoBusca).then((resposta) => {
            if (resposta) {
                setLaboratorios(resposta);

                if (resposta?.length === 0) {
                    setMensagem(MENSAGEM_NAO_EXISTEM_LABORATORIOS);
                }
                else {
                    setMensagem(MENSAGEM_PADRAO_TROCA_LABORATORIO);
                }
            }
        }).finally(() => setCarregando(false));
    }, 1000), [termoBusca]);

    const handleClickLinha = (codigo) => {
        setCodigoSelecionado(codigo);
    };

    const obterSessaoAutenticada = async () => {
        await trocarLaboratorio(codigoSelecionado)(store.dispatch);
        setCarregando(true);
        fecharModal();
    };

    useEffect(() => {
        atualizarLarguraPopper();

        window.addEventListener('resize', atualizarLarguraPopper);
        return () => {
            window.removeEventListener('resize', atualizarLarguraPopper);
        };
    }, [atualizarLarguraPopper]);

    useEffect(() => {
        listarLaboratorio();

        return () => {
            listarLaboratorio.cancel();
        };
    }, [listarLaboratorio]);

    return (
        <>
            <Box
                borderColor="transparent"
                display="flex"
                align="center"
                justifyContent="end"
                alignItems="center"
                xs={12}
            >
                <IconButton
                    className={classes.botaoMenuTexto}
                    onClick={handleToggle}
                    color={"primary"}
                >
                    {icone}
                </IconButton>
                <ClickAwayListener onClickAway={handleClose}>
                    <Popper
                        className={classes.popper}
                        open={aberto}
                        anchorEl={referenciaAncora.current}
                        role={undefined}
                        transition
                        style={{ zIndex: 99999, width: popperWidth }}
                        onClick={abrirModal}
                        placement="bottom-start"
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                                }}>
                                <Paper className={classes.alturaMaxima}>
                                    <Typography style={{ paddingLeft: '8px' }} onClick={() => setModalAberto(true)}>Trocar laboratório</Typography>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </ClickAwayListener>
            </Box>
            <ModalTrocaLaboratorio
                listarLaboratorios={listarLaboratorio}
                modalAberto={modalAberto}
                termoBusca={termoBusca}
                setTermoBusca={setTermoBusca}
                laboratorios={laboratorios}
                setLaboratorios={setLaboratorios}
                carregandoDados={carregando}
                fecharModal={fecharModal}
                handleClickLinha={handleClickLinha}
                trocarLaboratorio={obterSessaoAutenticada}
                codigoSelecionado={codigoSelecionado}
                setCodigoSelecionado={setCodigoSelecionado}
                mensagem={mensagem}
                setMensagem={setMensagem}
                ehUsuarioCpf={ehUsuarioCpf}
            />
        </>
    );
};

const useStyles = makeStyles(theme => ({
    alturaMaxima: {
        overflowY: "auto",
        borderRadius: "0px 0px 5px 5px",
        boxShadow: '0px 5px 8px rgba(0, 0, 0, 0.3)',
        borderTop: `2px solid ${SECONDARY_COLOR}`,
        height: '41px',
        display: 'flex',
        alignItems: 'center'
    },
    popper: {
        width: '100%',
        cursor: 'pointer'
    },
    botaoMenuTexto: {
        borderRadius: "3px",
    }
}));

const mapStateToProps = state => {
    return {
        autenticado: state.login.usuarioAutenticado,
        acessoNegado: state.login.acessoNegado
    }
}

export default connect(
    mapStateToProps
)(TrocaLaboratorio)
